export const forecastRiskColors = [
    { label: 'Green', value: '#00ab8a', class: 'green-6' },
    { label: 'Lime', value: '#83d295', class: 'green-2' },
    { label: 'Yellow', value: '#ffe13b', class: 'yellow-3' },
    { label: 'Amber', value: '#ffba04', class: 'amber-8' },
    { label: 'Orange', value: '#fe8231', class: 'orange-7' },
    { label: 'Red', value: '#d71808', class: 'red-3' },
];

export const gaugeRiskColors = [
    { label: 'Light Blue', value: '#87ceeb', class: 'light-blue' },
    { label: 'Sky Blue', value: '#6f8ee8', class: 'sky-blue' },
    { label: 'Violet', value: '#8a2be2', class: 'violet' },
    { label: 'Magenta', value: '#9f2492', class: 'magenta' },
    { label: 'Purple', value: '#561861', class: 'purple' },
    { label: 'Dark Purple', value: '#1c0030', class: 'dark-purple' },
];


export const timeZoneOptions = [
    'America/Edmonton',
    'America/Fort_Nelson',
    'America/Halifax',
    'America/Regina',
    'America/Toronto',
    'America/Vancouver',
    'America/Whitehorse',
    'America/Winnipeg',
    'America/New_York',
    'America/Chicago',
    'America/Denver',
    'America/Los_Angeles',
    'UTC'
];

export const statusDict = {
    'ACTIVE': {
        label: 'Latest Update',
        icon: 'mdi-check-circle',
        color: 'success-color',
    },
    'FAILED': {
        label: 'Not Available',
        icon: 'mdi-close-circle',
        color: 'failure-color',
    },
    'DELAYED': {
        label: 'Previous Update',
        icon: 'mdi-clock-outline',
        color: 'delay-color',
    },
    'SKIPPED': {
        label: null,
        icon: null,
        color: null,
    }
};

// Model precip map slices, different models use different time slicing params
// For example, ecmwf has 1 hour slices for first 90 hours, 3 hours for next 54 hours, and 6 hours for next 96
export const modelPrecipMapTiles = {
    nwm: {
        daysAvailable: 7,
        minZoom: 0,
        maxZoom: 4,
        bounds: [-133.51757173145077, 20.06499067634475, -60.48453913253368, 57.77754694727189]
    },
    ecmwf: {
        daysAvailable: 7,
        minZoom: 0,
        maxZoom: 4,
        bounds: [-139.05, 23.95, -50.95, 60.55]
    },
    hrdps: {
        daysAvailable: 2,
        minZoom: 0,
        maxZoom: 4,
        bounds: [-152.76853199999996, 27.24801490305109, -40.65878454188370, 70.62273200000000]
    },
    hrrr: {
        daysAvailable: 2,
        minZoom: 0,
        maxZoom: 4,
        bounds: [-134.12142793280142, 21.13159561982670, -60.86381651285446, 52.61760949663763]
    },
    ukmo: {
        daysAvailable: 7,
        minZoom: 0,
        maxZoom: 4,
        bounds: [-141.03999999999999, 24.10647949718037, -52.27924483896847, 70.55999999999999]
    },
    rdps: {
        daysAvailable: 4,
        minZoom: 0,
        maxZoom: 4,
        bounds: [-180, -3.85657144, 180, 90]
    }
};

export const assetLayer = {
    id: 'asset-layer',
    type: 'circle',
    source: 'asset-source',
    paint: {
        'circle-color': ['get', 'color'],
        'circle-radius': {
            'base': 3,
            'stops': [
                [4, 3],
                [7, 8],
                [10, 10],
            ]
        },
        'circle-stroke-color': '#FFF',
        'circle-stroke-width': 2,
    },
    layout: {
        'circle-sort-key': ['get', 'forecastRiskLevel']
    }
};

export const assetTextLayer = {
    id: 'asset-text-layer',
    type: 'symbol',
    source: 'asset-source',
    paint: {
        "text-color": ['get', 'textColor'],
    },
    layout: {
        "text-field": ['get', 'forecastRiskLevel'],
    },
    minzoom: 7,
    filter: ['>', ['get', 'forecastRiskLevel'], 0],
};

export const gaugeLayer = {
    id: 'gauge-layer',
    type: 'symbol',
    source: 'gauge-source',
    layout: {
        'icon-image': 'square',
        'icon-rotate': ['match', ['get', 'isVirtual'], 1, 45, 0],
        'icon-size': ['interpolate', ['linear'], ['zoom'],
            4, ['case', ['==', ['get', 'con'], true], 1.5, 0.2],
            7, ['case', ['==', ['get', 'con'], true], 2.5, 1],
            10, ['case', ['==', ['get', 'con'], true], 3, 1.5],
        ],
        'icon-allow-overlap': true,
        'icon-optional': true,
        'symbol-sort-key': ['case', ['==', ['get', 'con'], true], ["coalesce", ["get", "riskLevel"], 0], 0],
    },
    paint: {
        'icon-halo-width': 2,
        'icon-halo-color': '#fff',
        'icon-color': ['get', 'c'],
    },
};

export const gaugeTextLayer = {
    id: 'gauge-text-layer',
    type: 'symbol',
    source: 'gauge-source',
    paint: {
        "text-color": ['get', 'textColor'],
    },
    layout: {
        "text-field": ['get', 'riskLevel'],
        "symbol-sort-key": ["coalesce", ["*", -1, ["get", "riskLevel"]], 0],
    },
    minzoom: 7,
};

const baseHighlightLayer = {
    type: 'circle',
    layout: {
        visibility: 'visible'
    },
    filter: false,
};

export const assetHighlightLayer = {
    id: 'asset-highlight-layer',
    source: 'asset-source',
    ...baseHighlightLayer,
    paint: {
        'circle-color': 'orange',
        'circle-opacity': 0,
        'circle-radius': {
            'base': 5,
            'stops': [
                [4, 5],
                [7, 10],
                [10, 12],
            ]
        },
        'circle-stroke-width': 5,
        'circle-stroke-color': 'orange',
    },
};

export const gaugeHighlightLayer = {
    id: 'gauge-highlight-layer',
    source: 'gauge-source',
    type: 'symbol',
    layout: {
        'icon-image': 'square',
        'icon-rotate': ['match', ['get', 'isVirtual'], 1, 45, 0],
        'icon-size': ['interpolate', ['linear'], ['zoom'],
            4, ['case', ['==', ['get', 'con'], true], 3, 2.2],
            7, ['case', ['==', ['get', 'con'], true], 4.5, 3],
            10, ['case', ['==', ['get', 'con'], true], 5, 3.5],
        ],
        'icon-allow-overlap': true,
        'icon-optional': true,
        'symbol-sort-key': ['case', ['==', ['get', 'con'], true], 1, 0],
    },
    paint: {
        'icon-color': 'orange',
    },
    filter: false,
};

export const emptyMapData = {
    type: "FeatureCollection",
    features: []
};

export const overlayLineLayer = {
    id: 'overlay-line-layer',
    type: 'line',
    source: 'overlay-geojson',
    paint: {
        'line-color': ['get', 'color'],
        'line-width': 2,
    },
    filter: ['==', ['geometry-type'], 'LineString']
};
export const overlayFillLayer = {
    id: 'overlay-fill-layer',
    type: 'fill',
    source: 'overlay-geojson',
    paint: {
        'fill-color': ['get', 'color'],
        'fill-opacity': 0.3,
    },
    filter: ['==', ['geometry-type'], 'Polygon']
};
export const overlayPointLayer = {
    id: 'overlay-point-layer',
    type: 'circle',
    source: 'overlay-geojson',
    paint: {
        'circle-color': ['get', 'color'],
        'circle-radius': 4,
    },
    filter: ['==', ['geometry-type'], 'Point']
};

export const networkNames = {
    MSC: 'Water Survey of Canada',
    CEHQ: 'CEHQ (Quebec)',
    USGS: 'US Geological Survey',
    Floodhub: 'Google Virtual Gauges (forecast)',
};

export const fireYears = [0, 1, 2, 3, 4, 5];
export const latestFireYear = 2025 // new Date().getFullYear();
export const monthList = [ "January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December" ];

export const loadingSvg = `<svg xmlns="http://www.w3.org/2000/svg" class="text-center" width="50px" height="50px" viewBox="0 0 200 200">
    <radialGradient id="a12" cx=".66" fx=".66" cy=".3125" fy=".3125" gradientTransform="scale(1.5)">
        <stop offset="0" stop-color="#32617C"></stop><stop offset=".3" stop-color="#32617C" stop-opacity=".9"></stop>
        <stop offset=".6" stop-color="#32617C" stop-opacity=".6"></stop>
        <stop offset=".8" stop-color="#32617C" stop-opacity=".3"></stop>
        <stop offset="1" stop-color="#32617C" stop-opacity="0"></stop>
    </radialGradient>
    <circle transform-origin="center" fill="none" stroke="url(#a12)" stroke-width="15" stroke-linecap="round" stroke-dasharray="100 500" stroke-dashoffset="0" cx="100" cy="100" r="70">
        <animateTransform type="rotate" attributeName="transform" calcMode="spline" dur="2" values="360;0" keyTimes="0;1" keySplines="0 0 1 1" repeatCount="indefinite"></animateTransform>
    </circle>
    <circle transform-origin="center" fill="none" opacity=".2" stroke="#32617C" stroke-width="15" stroke-linecap="round" cx="100" cy="100" r="70"></circle>
</svg>`;
